// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"ce26d8f4","465":"fab521ac","787":"03dc50a3","834":"954d008f"}[chunkId] + ".chunk.js";
};